import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const styles = theme => ({
    iconSquare: {
        position: 'relative',
        width: '32px',
        border: '1px solid #E6EDF5',
        height: '32px',
        display: 'block',
        padding: '9px',
        borderRadius: '4px',
        marginTop: '14px',
        cursor: 'pointer',
        '& .square': {
            border: '2px solid #878787',
            height: '12px',
            width: '12px',
            position: 'relative',
            '& .iconBorderRight': {
                position: 'absolute',
                right: 0,
                border: '1px solid #878787',
                height: '100%'
            },
            '& .iconBorderBottom': {
                position: 'absolute',
                bottom: 0,
                border: '1px solid #878787',
                width: '100%'
            },
            '& .iconBorderLeft': {
                position: 'absolute',
                left: 0,
                border: '1px solid #878787',
                height: '100%'
            },
            '& .iconBorderTop': {
                position: 'absolute',
                top: 0,
                border: '1px solid #878787',
                width: '100%'
            },
        },
        '&:hover, &.active': {
            '& .square': {
                border: '2px solid #6EA0D7',
                '& .iconBorderRight': {
                    border: '1px solid #6EA0D7',
                },
                '& .iconBorderBottom': {
                    border: '1px solid #6EA0D7',
                },
                '& .iconBorderLeft': {
                    border: '1px solid #6EA0D7',
                },
                '& .iconBorderTop': {
                    border: '1px solid #6EA0D7',
                },
            },
        },
        '&:hover': {
            backgroundColor: '#E6EDF5',            
        }
    }
});


const Icon = (props) => {
    const { classes, name, isActive, onClick } = props;
    let icon = '';
    switch (name) {
        case 'hideFooter':
            icon = <div className={"iconBorderBottom"}></div>
            break;
        case 'hideRight':
            icon = <div className={"iconBorderRight"}></div>
            break;
        case 'hideLeft':
            icon = <div className={"iconBorderLeft"}></div>
            break;
        case 'hideTop':
            icon = <div className={"iconBorderTop"}></div>
            break;
        default:
            break;
    }

    return (
        <div onClick={onClick} className={isActive === true ? classes.iconSquare : clsx(classes.iconSquare, 'active')}>
            <div className={"square"}>
                {icon}
            </div>
        </div>
    )
}
export default withStyles(styles)(Icon);

